<template>
  <v-app>
    <v-system-bar class="d-print-none pt-3" height="30" app lights-out>
      <v-toolbar-items class="ml-5">
        <v-btn
          href="javascript:window.print()"
          class="title elevation-0 mr-2"
          color="grey darken-1"
          x-large
        >
          <v-icon>mdi-printer</v-icon>&nbsp; พิมพ์
        </v-btn>
        <v-btn
          @click.stop="Export2Doc('exportContent', 'word-content-1-4')"
          class="title elevation-0"
          color="grey darken-1"
          x-large
        >
          <v-icon>mdi-file-word</v-icon>&nbsp; Export to Word
        </v-btn>
      </v-toolbar-items>
    </v-system-bar>

    <div id="exportContent">
      <div class="page">
        <div class="">
          <!-- หน้าที่ 1 -->
          <div class="text-right text_j">
            สัญญาจ้างเลขที่
            <span class="dotted-underline">
              {{ government_employee.id_office }}-{{
                government_employee.id_position
              }}/{{ years }}</span
            >
          </div>

          <div class="text-right text_j">
            {{ government_employee.college_name }}
          </div>

          <div class="text-center bold16 text_j">สัญญาแก้ไขเพิ่มเติม</div>
          <div class="text-center bold16 text_j">
            สัญญาจ้างพนักงานราชการ
          </div>

          <div class="div-indent text_j mt-5">
            <span class="div-indent text_j">
              สัญญาแก้ไขเพิ่มเติมฉบับนี้ ทําขึ้น ณ
              สํานักงานคณะกรรมการการอาชีวศึกษา เมื่อวันที่
              <span class="dotted-underline"> 1 ตุลาคม 2568</span>
              ระหว่างสํานักงานคณะกรรมการการอาชีวศึกษา โดย<span
                class="dotted-underline"
              >
                {{ government_employee.user_director }}</span
              >

              ตําแหน่ง
              <span class="dotted-underline"
                >ผู้อำนวยการ{{ government_employee.user_firstname }}</span
              >

              ผู้แทน/ผู้รับมอบอํานาจตามคําสั่งสํานักงานคณะกรรมการการอาชีวศึกษา
              ที่
              <span class="dotted-underline">
                {{ power_attorney_1.power_attorney_order }}
              </span>
              ลงวันที่
              <span class="dotted-underline">
                {{ power_attorney_1.power_attorney_datetime }}
              </span>

              <span v-if="collegeinfo.collegeinfo_director_type === '1'">
                และ คําสั่งสํานักงานคณะกรรมการการอาชีวศึกษา ที่
                <span class="dotted-underline">
                  {{ power_attorney_2.power_attorney_order }}
                </span>
                ลงวันที่ {{ power_attorney_2.power_attorney_datetime }}</span
              >

              ซึ่งต่อไป ในสัญญานี้เรียกว่า "สํานักงาน" ฝ่ายหนึ่ง กับ
              <span class="dotted-underline">
                {{ personnel_temporary_govems.frist_names }}
              </span>

              อายุ<span class="dotted-underline"> {{ get_ageUser }} </span>ปี
              วัน/เดือน/ปี เกิด<span class="dotted-underline">
                {{
                  personnel_temporary_govems.brith_day +
                    "/" +
                    personnel_temporary_govems.brith_month +
                    "/" +
                    personnel_temporary_govems.brith_year
                }}
              </span>
              หมายเลขประจําตัวของผู้ถือบัตรประจําตัวประชาชน
              <span class="dotted-underline">
                {{ personnel_temporary_govems.id_card }}
              </span>

              อยู่บ้านเลขที่
              <span class="dotted-underline">
                {{ personnel_temporary_govems.pt_homeid }} หมู่
                {{ personnel_temporary_govems.pt_moo }} </span
              >ถนน
              <span class="dotted-underline">
                {{ personnel_temporary_govems.pt_road || "-" }}
              </span>
              แขวง/ตําบล
              <span class="dotted-underline">
                {{ personnel_temporary_govems.district_name || "-" }}
              </span>

              เขต/อําเภอ
              <span class="dotted-underline">
                {{ personnel_temporary_govems.prefecture_name || "-" }}
              </span>
              จังหวัด
              <span class="dotted-underline">
                {{ personnel_temporary_govems.addr_province_name || "-" }}
              </span>
              รหัสไปรษณีย์
              <span class="dotted-underline">
                {{ personnel_temporary_govems.addr_district_post || "-" }}
              </span>

              โทรศัพท์
              <span class="dotted-underline">
                {{ personnel_temporary_govems.tel_p || "-" }}
              </span>

              ระดับการศึกษา
              <span class="dotted-underline">{{
                personnel_temporary_govems.ed_abb_level || "-"
              }}</span>
              วุฒิการศึกษา
              <span class="dotted-underline"
                >{{ personnel_temporary_govems.ed_abb || "-" }}
              </span>
              สาขา
              <span class="dotted-underline">{{
                personnel_temporary_govems.ed_name || "-"
              }}</span>
              สถาบันที่จบ
              <span class="dotted-underline"
                >{{ personnel_temporary_govems.ed_university || "-" }}
              </span>
              วันที่เริ่มศึกษา
              <span class="dotted-underline">
                {{
                  formatDate(personnel_temporary_govems.ed_university_datebegin)
                }}
              </span>
              วันสำเร็จการศึกษา
              <span class="dotted-underline">
                {{
                  formatDate(personnel_temporary_govems.ed_university_dateend)
                }}</span
              >
            </span>

            ซึ่งต่อไปในสัญญานี้เรียกว่า "พนักงานราชการ" อีกฝ่ายหนึ่ง
          </div>

          <div class="text_j div-indent">
            โดยที่ สำนักงานคณะกรรมการการอาชีวศึกษา
            และพนักงานราชการได้ทำสัญญาจ้างพนักงานราชการ สัญญาเลขที่
            <span class="dotted-underline">
            {{ government_employee.id_office }}-{{
                government_employee.id_position
              }}/{{ years }} </span> ลงวันที่ <span class="dotted-underline">
                {{ formatDate(order_appoint.start_date) }}
              </span>
              
              ไว้ต่อกัน
            ซึ่งต่อไปสัญญาแก้ไขเพิ่มเติมฉบับนี้ เรียกว่า “สัญญาจ้าง”
            คู่สัญญาทั้งสองฝ่ายได้ตกลงกันทำการแก้ไขเพิ่มเติมสัญญาจ้าง
            ดังต่อไปนี้
          </div>

          <div class="text_j div-indent">
            ข้อ 1 ตามสัญญาจ้างหรือคำสั่งสำนักงานคณะกรรมการการอาชีวศึกษา ที่
            <span class="dotted-underline">{{ government_employee_old.id_office }}-{{
                government_employee_old.id_position
              }}/.....................</span>
            ลงวันที่....................................................
            กำหนดให้พนักงานราชการปฏิบัติงานที่
           <span class="dotted-underline"> “ {{ government_employee_old.college_name }} ” </span>
            นั้น
            เพื่อให้การปฏิบัติงานเป็นไปอย่างมีประสิทธิภาพและสอดคล้องกับภารกิจในปัจจุบัน
            จึงให้พนักงานราชการย้ายไปปฏิบัติงานที่
             <span class="dotted-underline"> “ {{ government_employee.college_name }} ” </span>

            โดยได้รับความยินยอมจากพนักงานราชการแล้ว ทั้งนี้ ความนอกเหนือ
            จากที่แก้ไขเพิ่มเติมดังกล่าวให้เป็นไปตามสัญญาจ้างทุกประการ
            และให้ถือว่าสัญญาแก้ไขเพิ่มเติมฉบับนี้เป็นส่วนหนึ่งของสัญญาจ้าง
          </div>

          <div class="text_j div-indent">
            ข้อ 2 การย้ายตามข้อ 1 ให้มีผลตั้งแต่วันที่
             {{ formatDate(order_appoint.start_date) }}
            เป็นต้นไป
          </div>
          <div class="text_j div-indent">
            สัญญาแก้ไขเพิ่มเติมฉบับนี้ทำขึ้นสองฉบับมีข้อความถูกต้องตรงกัน
            คู่สัญญาอ่านตรวจสอบและเข้าใจข้อความในสัญญาโดยละเอียดแล้ว
            จึงลงลายมือชื่อไว้เป็นหลักฐานต่อหน้าพยาน ณ วัน เดือน ปี
            ดังกล่าวข้างต้น และต่างฝ่ายต่างเก็บรับษาไว้ฝ่ายละฉบับ
          </div>
        </div>

        <div class="">
          <br />
          <br />
          <br />
          <br />
          <table class="text_j" border="0" width="100%">
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (ลงชื่อ.........................................................สถาบัน
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (...................................................................)
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (ลงชื่อ).........................................................พนักงานราชการ
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (...................................................................)
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (ลงชื่อ).........................................................พยาน
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (...................................................................)
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (ลงชื่อ).........................................................พยาน
              </td>
            </tr>
            <tr>
              <td width="50%"></td>
              <td class="text-center">
                (...................................................................)
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "Report",
  data() {
    return {
      ApiKey: "HRvec2021",
      personnel_temporary_govems: [],
      period_college: [],
      conditons_transfer_success_govem: [],
      government_employee: [],
      years: "",
      collegeinfo: [],
      power_attorney_1: [],
      power_attorney_2: [],
      government_employee_old:[],
      order_appoint:[],
    };
  },
  async mounted() {
    await this.periodQuery();
    await this.conditons_transfer_success_govemQuery();
    await this.government_employeeQuery();
    await this.government_employeeOldQuery();
    await this.personnel_temporary_govemQuery();
    await this.collegeinfoQuery();
    await this.power_attorney_1Query();
    await this.power_attorney_2Query();
    await this.order_appointQuery();
  },
  computed: {
    pid() {
      return this.$route.query.pid;
    },
    date_today_cal() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },

    get_ageUser() {
      let today = new Date(this.date_today_cal);
      let DOB = new Date(
        parseInt(this.personnel_temporary_govems.brith_year) -
          543 +
          "-" +
          this.personnel_temporary_govems.brith_month +
          "-" +
          this.personnel_temporary_govems.brith_day
      );
      let totalMonths =
        (today.getFullYear() - DOB.getFullYear()) * 12 +
        today.getMonth() -
        DOB.getMonth();
      totalMonths += today.getDay() < DOB.getDay() ? -1 : 0;
      let years = today.getFullYear() - DOB.getFullYear();
      if (DOB.getMonth() > today.getMonth()) years = years - 1;
      else if (DOB.getMonth() === today.getMonth())
        if (DOB.getDate() > today.getDate()) years = years - 1;

      let days;
      let months;

      if (DOB.getDate() > today.getDate()) {
        months = totalMonths % 12;
        if (months == 0) months = 11;
        let x = today.getMonth();
        switch (x) {
          case 1:
          case 3:
          case 5:
          case 7:
          case 8:
          case 10:
          case 12: {
            let a = DOB.getDate() - today.getDate();
            days = 31 - a;
            break;
          }
          default: {
            let a = DOB.getDate() - today.getDate();
            days = 30 - a;
            break;
          }
        }
      } else {
        days = today.getDate() - DOB.getDate();
        if (DOB.getMonth() === today.getMonth()) months = 0;
        else months = totalMonths % 12;
      }
      let age = years + " ปี";
      return age;
    }
  },
  methods: {
     async order_appointQuery() {
      let result = await this.$http.post("order_appoint.php", {
         ApiKey: this.ApiKey,
          name_position:"พนักงานราชการ"
      });
      this.order_appoint = result.data;
    },

    async power_attorney_1Query() {
      let result = await this.$http.post("power_attorney.php", {
        ApiKey: this.ApiKey,
        power_attorney_id: "101"
      });
      this.power_attorney_1 = result.data;
    },

    async power_attorney_2Query() {
      let result = await this.$http.post("power_attorney.php", {
        ApiKey: this.ApiKey,
        power_attorney_id: "102"
      });
      this.power_attorney_2 = result.data;
    },
    async collegeinfoQuery() {
      let result = await this.$http.post("collegeinfo.php", {
        ApiKey: this.ApiKey,
        collegeinfo_code: this.conditons_transfer_success_govem.ctscollege_code
      });
      this.collegeinfo = result.data;
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      date.setFullYear(date.getFullYear()); // +543 ปี (พ.ศ.)
      return new Intl.DateTimeFormat("th-TH", {
        day: "numeric",
        month: "long",
        year: "numeric"
      }).format(date);
    },

    async periodQuery() {
      let result_period;
      result_period = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: "80103"
      });
      this.period_college = result_period.data; 
      if (this.period_college.period_college_enable != "1") {
        //this.$router.push("/");
      }
      let years = parseInt(this.period_college.period_college_year) + 1;
      this.years = years;
    },

    async conditons_transfer_success_govemQuery() {
      let result = await this.$http.post(
        "conditons_transfer_success_govem.php",
        {
          ApiKey: this.ApiKey,
          ctsid_card: this.pid,
          ctstime_s: this.period_college.period_college_times,
          ctsyear_s: this.period_college.period_college_year
        }
      );
      this.conditons_transfer_success_govem = result.data;  
    },

    async government_employeeQuery() {
      let result = await this.$http.post("government_employee_idposition.php", {
        ApiKey: this.ApiKey,
        id_position: this.conditons_transfer_success_govem.ctsid_position
      });
      this.government_employee = result.data;     
    },

    async government_employeeOldQuery() {
      let result = await this.$http.post("government_employee_idposition.php", {
        ApiKey: this.ApiKey,
        id_position: this.conditons_transfer_success_govem.ctsid_postion_old
      });
      this.government_employee_old = result.data;     
    },

    

    async personnel_temporary_govemQuery() {
      let result = await this.$http.post("personnel_temporary_govem.php", {
        ApiKey: this.ApiKey,
        id_card: this.pid
      });
      this.personnel_temporary_govems = result.data;
      
    },

    Export2Doc(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-16'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword"
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-16," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".doc" : "document.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    }
  }
};
</script>

<style>
body {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16px;
  font-weight: 250;
}

.u {
  border-bottom: 1px dotted #000;
  text-decoration: none;
}
u {
  border-bottom: 1px dotted #000;
  text-decoration: none;
}

.dotted-underline {
  border-bottom: 1px dotted black;
  text-decoration: none; /* ปิดเส้นใต้แบบปกติ */
}

* {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
p.indent {
  text-indent: 10px;
}
.div-indent {
  text-indent: 3em;
}

.div-indent-sec {
  text-indent: 4em;
}

.table,
.th,
.td {
  border-bottom: 0.5px solid black;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-collapse: collapse;
}

.text_j {
  border-collapse: collapse;
  text-align: justify;
  text-justify: inter-word;
  line-height: 1;
}
.text_l {
  border-collapse: collapse;
  text-align: left;
  text-justify: inter-word;
  line-height: 1;
}

tfoot tr:hover {
  background-color: initial;
}

tbody tr:hover {
  background-color: inherit;
}

td,
th {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
}

tfoot td {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-weight: bold;
}

#verticaltext {
  writing-mode: tb-rl;
  filter: flipv fliph;
  -webkit-transform: rotate(-90deg);
  white-space: nowrap;
  display: block;
  overflow: hidden;
  padding: 0;
}

.page {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  width: 21cm;
  min-height: 29.7cm;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin-top: 0cm;
  margin-right: auto;
  margin-bottom: 0cm;
  margin-left: auto;
  padding-top: 1cm;
  padding-right: 1cm;
  padding-bottom: 1cm;
  padding-left: 1cm;
}

.head {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 22pt;
  font-weight: bold;
  line-height: 1.5;
}

.regular12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
}

.regular16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
}

.bold16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
}

.blod12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
  font-weight: bold;
}

.blackRegula10 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 12pt;
}

.blackBold18 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 18pt;
  font-weight: bold;
}

.largerCheckbox {
  width: 30px;
  height: 30px;
  color: blue;
}
.td_line {
  border-bottom: 1pt dotted black;
}
/*.subpage {
      height: 247mm;
    }*/

.BlackBold10 {
  font-weight: bold;
}

#content {
  display: table;
}

#pageFooter {
  display: table-footer-group;
}

#pageFooter:after {
  counter-increment: page;
  content: counter(page);
}

@media print {
  .page {
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    padding-top: 1cm;
    padding-right: 1cm;
    padding-bottom: 1cm;
    padding-left: 1.5cm;
  }

  .head {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  .regular12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .regular16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .bold16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blod12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blackRegula10 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 14pt;
  }

  .blackBold18 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  /* .head {
        font-size: 18px;
        font-weight: bold;
      }
      .regular12 {
        font-size: 12px;
      }
      .blod12 {
        font-size: 12px;
        font-weight: bold;
      }
      .blackRegula8 {
        font-size: 8px;
      } */
  .noprint {
    display: none;
  }

  .gap-10 {
    width: 100%;
    height: 10px;
  }
  .gap-20 {
    width: 100%;
    height: 20px;
  }
  .gap-30 {
    width: 100%;
    height: 30px;
  }
}
</style>
